<template>
    <div class="wapper flex flex-direction bg-white radius padding-sm">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item v-for="(item,index) in list" :key="index" :name="index">
                <template slot="title">
                    <p style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
                        {{ item.title }} <span style="">{{ item.create_time }}</span>
                    </p>
                </template>
                <div>
                    <div v-html='item.content'></div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import {zhDate} from "@/utils/utils";
import {messageList} from "@/api";

export default {
    name: "list",
    data() {
        return {
            list: [],  //  自定义列表
            activeName: '1'
        }
    },
    created() {
        this.$emit('setIndex', [2, 1], '消息中心')
        this.init()
    },
    methods: {
        async init() {
            let _data = await messageList()
            _data.data.map(item => {
                item.create_time = zhDate(item.create_time * 1000, 1)
            })
            this.list = _data.data
        },
    }
}
</script>

<style lang="scss" scoped>
.wapper {
    .items {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 70px;
        padding: 10px 20px;
        line-height: 50px;
        border-bottom: 1px solid #f3f3f3;

        .item-name {
            width: 400px;
        }

        .item-time {
            width: 200px;
        }

        .item-btn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 300px;

            .btns {
                border-color: #d9dde3;


                i {
                    font-size: 18px;
                    margin-right: 3px;
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
}
</style>